<template>
    <!--Waiting List Enroll Info Secound Screen-->
    <div class="enroll-info-screen">
        <div class="enroll-wrapper">
            <p>{{ $t("waitingListEnroll.secoundScreenP") }}</p>
            <p v-html="$t('waitingListEnroll.secoundScreenP2')"></p>
            <div class="custom-parahraph">
                <p class="title-bold">Client Notification Costs:</p>
                <p>
                    Stay informed with the waitlist feature, which includes
                    <span class="title-bold">free app notifications</span> for all users.
                </p>
                <p>
                    For instant alerts, <span class="title-bold">text message</span> and
                    <span class="title-bold">email</span> notifications are available at an additional cost:
                </p>
                <ul>
                    <li>
                        100 text messages (SMS) for {{ profileCurrency }}{{ costPerPackMethod(costPerSms, 100) }} ({{ profileCurrency }}{{ costPerSms }}/text)
                    </li>
                    <li>1,000 emails for ${{ costPerPackMethod(costPerEmail, 1000) }} ({{ profileCurrency }}{{ costPerEmail }}/email)</li>
                </ul>
                <p>
                    For questions, feel free to contact us at
                    <a class="main-text-link" href="mailto:info@ringmystylist.com">info@ringmystylist.com.</a>
                </p>
            </div>
            <p>
                <span class="title-bold">Billing:</span> <br />
                You’ll receive <b>one month free</b>. After the first month, if you don’t cancel, your card will be
                automatically charged
                <b>
                    {{ profileCurrency }}{{ enrollmentCostYearly }} for the full year
                </b>
                in advance.
            </p>
            <p v-html="$t('waitingListEnroll.secoundScreenP5')"></p>
        </div>
        <!--Waiting List Enroll Start the enrollment process Button-->
        <div class="enroll-btn-secound-screen">
            <button @click="changeScreen('enroll-step-one')" class="primary-btn extra-small mobile">
                Start the enrollment process
            </button>
            <button @click="changeScreen('first-screen')" class="secondary-btn small mobile">
                {{ $t("general.goBack") }}
            </button>
        </div>
        <!--Enroll later link-->
        <div class="maybe-later">
            <router-link class="main-text-link" :to="{ path: '/app' }">Maybe later</router-link>
            <span>
                (or text us at <a href="tel:619.888.3886" class="main-text-link">619.888.3886</a> with questions)</span
            >
        </div>
    </div>
</template>

<script>
import store from "../../../../services/vuex";
import eventBus from "../../../../services/eventBus";

export default {
    data() {
        return {
            smsAllowedCountries: [],
            costPerSms: 0,
            costPerEmail: 0,
            costPerPack: 0,
            profile: {},
            profileCurrency: "$",
            enrollmentCost: 1,
            enrollmentCostYearly: 12,
        };
    },
    computed: {
        adminDetails: {
            get: function () {
                return this.$store.state.adminDetails;
            },
            set: function (value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
    },
    mounted() {
        this.smsAllowedCountries = import.meta.env.VITE_SMS_ALLOWED_COUNTRIES.split(",");

        //check if adminDetails are either in store or loaded
        //if yes then do necessary logic
        if (this.$store.state.adminDetails.user) {
            this.onAdminDetailsLoad();
        }
        let self = this;
        eventBus.on("admin_details_loaded", function () {
            self.onAdminDetailsLoad();
        });

        this.enrollmentCost = import.meta.env["VITE_ENROLLMENT_COST"];
        this.enrollmentCostYearly = import.meta.env["VITE_ENROLLMENT_COST_YEARLY"];
    },
    components: {},
    methods: {
        changeScreen(screen) {
            this.$emit("change-screen", screen);
        },
        onAdminDetailsLoad: function () {
            if (this.smsAllowedCountries.indexOf(this.adminDetails.profile.country_id.toString()) > -1) {
                this.costPerSms = parseFloat(import.meta.env["VITE_SMS_COST_" + this.adminDetails.profile.country_id]);
            } else {
                this.costPerSms = parseFloat(import.meta.env["VITE_SMS_COST_0"]);
            }

            this.costPerEmail = parseFloat(import.meta.env["VITE_EMAIL_COST"]);
            this.getStylistProfile();
        },
        costPerPackMethod(msgType, pack) {
            return this.costPerPack = (msgType * pack).toFixed(2);
        },
        getStylistProfile() {
            this.profile = this.adminDetails.profile;
        },
    },
};
</script>
